import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import Nav from '~/components/nav';
import MarkdownNode from '~/components/markdown-node';
import { $UserAgent, $Locale } from '@lemon8/web-app-shared/atom';
import { $LegalEnterTraffic } from 'shared/atoms';
import EN from './docs/en.md';
import GB from './docs/gb.md';
import AU from './docs/au.md';
import NZ from './docs/nz.md';
import CA from './docs/ca.md';
import SG from './docs/sg.md';
import ID from './docs/id.md';
import JP from './docs/jp.md';
import MY from './docs/my.md';
import TH from './docs/th.md';
import VN from './docs/vn.md';
import US from './docs/us.md';

const docMap: Record<string, string> = {
  gb: GB,
  au: AU,
  nz: NZ,
  ca: CA,
  sg: SG,
  id: ID,
  jp: JP,
  my: MY,
  th: TH,
  vn: VN,
  us: US,
};

export const PolicyBody: FC = () => {
  const { isMobile, isInApp } = useAtomValue($UserAgent);
  const { region } = useAtomValue($Locale);
  const { shouldUpdateLegalContent = false } = useAtomValue($LegalEnterTraffic);

  // 当 shouldUpdateLegalContent 为 true 时,使用对应国家的 md 文件
  // 否则统一使用 en.md
  const src = shouldUpdateLegalContent && docMap[region] ? docMap : EN;

  return (
    <>
      {!isInApp && <Nav />}
      <MarkdownNode isMobile={isMobile} isInApp={isInApp} src={src} />
    </>
  );
};
